export { default as ImageSingular } from './ImageSingular';